import { render } from "./authentication.vue?vue&type=template&id=ee8d984e&scoped=true&ts=true"
import script from "./authentication.vue?vue&type=script&lang=ts"
export * from "./authentication.vue?vue&type=script&lang=ts"

import "./authentication.vue?vue&type=style&index=0&id=ee8d984e&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee8d984e"]])

export default __exports__